define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/agentView.tmpl");
    var BaseCollection = require("collections/BaseCollection");
    var AgentItemView = require("manager-views/data-sources/attributes/AgentItemView");
    var Button = require("ui/button/Button");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var Multiselect = require("ui/multiselect/Multiselect");
    var ToggleButton = require("ui/toggle-button/toggleButton");

    var AgentView = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        AgentView = Marionette.CompositeView.extend({
            template: template,
            itemView: AgentItemView,
            itemViewContainer : ".agent-list",
            ui: {
                "saveButton": ".button-save-edit",
                "skills": ".skills-container .input-container",
                "skillsContainer": ".skills-container",
                "toggleContainer": ".toggle-show-edit",
                "footer": ".list-footer"
            },

            uiComponents: {
                saveBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.DISABLED
                    },
                    events: {
                        "click": "saveProperties"
                    }
                },
                skills: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.skills",
                        permutation: Multiselect.PERMUTATION.MEDIUM2,
                        trim: true,
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEManager.manager.dataSources.agent.tab.header.skills.placeholder"),
                            tagMaxWidth: "275px"
                        },
                        items: "view._getSkillsItems"
                    },
                    events: {
                        select: "_onSkillsChange",
                        unselect: "_onSkillsChange"
                    }
                }
            },
            initialize: function (options) {
                LEManager.logger.debug("AgentView:initialize");
                //the current collection. it is updated everytime a change is done in one of the properties (map by dropdown or the value textbox)
                this.vent = LEManager.media.channel("dataSources").vent;
                this.model = options.model;
                this.skillsCollection = options.skillsCollection;

                this.itemViewOptions = {
                    attributesModel: options.model
                };

                this._bindEvents();
            },

            _bindEvents: function(){
                this.listenTo(this.collection, 'change', this.collectionChanged);
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE_DONE,this.onAgentSaveDone, this);
            },
            _onSkillsChange: function(componentId, eventName, item) {
                var skills = this.uiComponents.skills.getSelectedItems();
                this.model.setAgentOutcomeSkills(skills);
                this.uiComponents.saveBtn.setState(Button.STATES.ENABLED);
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.SKILLS_CHANGED, this.model);
            },
            _getSkillsItems: function() {
                var skillsArr = [];
                this.skillsCollection.each(function(skillModel) {
                    skillsArr.push({
                        id: skillModel.id,
                        value: skillModel.getName(),
                        selected: _.include(this.model.getAgentOutcomeSkills(), skillModel.id)
                    });
                }, this);

                return skillsArr;
            },

            onRender: function(){
                LEManager.logger.debug("AgentView:onRender");
                this.positionSaveButton();

                //this.$el.find("li.agent-item").css("pointer-events", "none");
                //this.uiComponents.skills.setEnabled(false);
            },

            positionSaveButton: function(){
                LEManager.logger.debug("AgentView:positionSaveButton");
                var numberOfEditableRows = this.collection.getNumberOfEditableProperties();
                var totalRows = this.collection.length;
                var top = 0 - (totalRows * ManagerConfig.dataSources.mainConfig.agent.rowHeight) + (numberOfEditableRows * ManagerConfig.dataSources.mainConfig.agent.rowHeight);
                LEManager.logger.debug("AgentView:positionSaveButton - top: " + top);
                $(this.ui.footer).css("top", top + "px");
                $(this.ui.skillsContainer).css("top", top + "px");
            },

            onAgentSaveDone: function(result){
                LEManager.logger.debug("AgentView:onAgentSaveDone - result.isSuccess: " + result.isSuccess);
                if (result.isSuccess){
                    //we disable the specific clicked save button and ventually clean errors after a successfull save
                    if (!_.isUndefined(result.model) && result.model.id === this.model.id){
                        this.uiComponents.saveBtn.setState(Button.STATES.DISABLED);
                        LEManager.logger.debug("AgentView:onAgentSaveDone - before clearing all childViews errors");
                        this.children.each(function(itemView){
                            itemView.clearErrors();
                        });
                    }
                }
            },

            collectionChanged: function(model){
                LEManager.logger.debug("AgentView:collectionChanged");
                var currentState = this.uiComponents.saveBtn.getState();
                if (currentState === Button.STATES.DISABLED && model.hasAgentOutcomePropertyChanges()){
                    this.uiComponents.saveBtn.setState(Button.STATES.ENABLED);
                }
            },

            saveProperties: function(){
                LEManager.logger.debug("AgentView:saveProperties");
                if (this.validatePropertiesByModel()){//validation is ok. save can be performed
                    this.vent.trigger(ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE, { model: this.model, collection: this.collection });
                }
                else {
                    LEManager.logger.info("AgentView:saveProperties - model is not valid - showing error notification");
                    LEManager.notifier.showError({
                        content: LE.translator.translate("LEManager.manager.dataSources.edit.validation.error")});
                }
            },

            validatePropertiesByModel: function(){
                LEManager.logger.debug("AgentView:validatePropertiesByModel");
                var result = this.collection.areModelsValid();
                LEManager.logger.debug("AgentView:validatePropertiesByModel - result: " + result);
                return result;
            },

            onClose: function() {
                this.stopListening(this.collection);
                LEManager.logger.debug("AgentView:onClose");
            }
        });
    });
    return AgentView;
});

